/**
 * EditableMarkup - Core Component
 *
 * Renders a CMS editor's field markup (e.g. TYPO3's <ve-editable-rich-text>)
 * verbatim. The editor's web components take the DOM over once they load:
 * they read the inner HTML as the field value and mount a rich text editor
 * in it. React must therefore neither parse nor reconcile it, and it must
 * not complain when it finds that DOM already changed at hydration.
 *
 * Edit mode only; the markup comes from the logged-in editor's own CMS.
 */
import type { ElementType, ReactNode } from 'react';

export interface EditableMarkupProps {
  html: string;
  as?: ElementType;
  className?: string;
}

/**
 * A text field that the CMS editor may take over: its editable markup when
 * present (visual editor), otherwise the regular content.
 */
export function EditableText({ markup, children }: { markup?: string; children?: ReactNode }) {
  return markup ? <EditableMarkup as="span" html={markup} /> : children;
}

export function EditableMarkup({ html, as: Tag = 'div', className }: EditableMarkupProps) {
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
      suppressHydrationWarning
    />
  );
}
